import { UserRole } from "../enums/user-role.enum";
import { Permission } from "./permission.enum";

export const RolePermissions: Record<UserRole, Permission[]> = {
  [UserRole.ADMIN]: Object.values(Permission),
  [UserRole.USER]: [
    Permission.USERS_READ,
    Permission.USERS_UPDATE,
    Permission.USER_NOTIFICATIONS_READ,
    Permission.USER_NOTIFICATIONS_UPDATE,
  ],
};
